
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.156 4.208A53.585 53.585 0 0114.928 1 53.511 53.511 0 013.7 4.208 1.961 1.961 0 002 6.045C2 21.724 12.9 29 14.928 29s12.927-7.276 12.927-22.956a1.962 1.962 0 00-1.699-1.836zm-3.023 6.553L13.7 20.2a1.594 1.594 0 01-2.254 0l-4.72-4.719a1.594 1.594 0 112.254-2.254l3.592 3.592 8.31-8.312a1.594 1.594 0 112.254 2.254z","fill":"#222"}})])
          )
        }
      }
    